import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import { BeatLoader } from 'react-spinners';
import ServiceDetails from '../service-details';
import actions from 'api/actions';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import styles from '../styles.module.scss';

class ServiceDetailsSlugWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plans: null,
      learningCenters: null
    };

    this.refreshServices = this.refreshServices.bind(this);
  }

  componentDidMount() {
    actions.get('plans')
      .then(r => this.setState({ plans: r.data }))
      .catch(e => Sentry.captureException(e));

    actions.get('learning_centers')
      .then(({ data: learningCenters }) => this.setState({ learningCenters }))
      .catch(e => Sentry.captureException(e));
  }

  refreshServices() {
    actions.get('plans')
      .then(r => this.setState({ plans: r.data }))
      .catch(e => Sentry.captureException(e));
  }

  render() {
    const { slugOrId, selectedLearningCenterId } = this.props.match.params;
    const { plans, learningCenters } = this.state;

    if (!plans || !learningCenters) {
      return (
        <div className={styles.loadingSpinner}>
          <BeatLoader size={75} />
        </div>
      );
    }

    const foundPlan = _.find(plans, plan => {
      if (Number(slugOrId) === Number(plan.id)) { return true; }

      if (plan.slug === slugOrId) {
        return true;
      }

      return false;
    });

    if (!foundPlan) {
      return <Redirect to="/unyted-learning-centers/all" />;
    }

    return (
      <ServiceDetails
        planId={foundPlan.id}
        plans={plans}
        learningCenters={learningCenters}
        selectedLearningCenterId={selectedLearningCenterId}
        refreshServices={this.refreshServices}
        {...this.props}
      />
    );
  }
}

export default ServiceDetailsSlugWrapper;
